/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { candidateEventResponseActorTypeSchema } from './CandidateEventResponseActorTypeSchema'
import { candidateEventResponseTypeSchema } from './CandidateEventResponseTypeSchema'

export const candidateEventResponseSchema = z.object({
	id: z.string(),
	type: candidateEventResponseTypeSchema,
	actorType: candidateEventResponseActorTypeSchema,
	actorId: z.string().nullable(),
	occurredAt: z.iso.datetime(),
	context: z.record(z.string(), z.unknown()),
	booking: z.object({
		id: z.string(),
		status: z.union([z.literal('confirmed'), z.literal('cancelled')]),
		candidateAttended: z.boolean().nullable(),
		meeting: z.object({
			type: z.union([
				z.literal('jobilla_meet'),
				z.literal('google_meet'),
				z.literal('teams'),
				z.literal('zoom'),
				z.literal('phone'),
				z.literal('in_person'),
				z.literal('custom'),
			]),
			startsAt: z.iso.datetime(),
			endsAt: z.iso.datetime(),
			joinableAt: z.iso.datetime(),
			expiresAt: z.iso.datetime(),
			duration: z.number(),
			locationDetails: z.string().nullable(),
			candidateLink: z.string().nullable(),
			recruiterLink: z.string().nullable(),
		}),
	}).nullable(),
})

export type CandidateEventResponseSchema = z.infer<typeof candidateEventResponseSchema>
